var _rect, _path, _circle, _circle2, _circle3, _path2, _g, _rect2, _path3, _path4, _path5, _rect3, _g2, _rect4, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEvmDark = function SvgEvmDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0857143,
    y: 0.0857143,
    width: 23.8286,
    height: 23.8286,
    rx: 1.91429,
    fill: "#2A235B",
    stroke: "#130E3A",
    strokeWidth: 0.171429
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0857143 2C0.0857143 0.94277 0.942769 0.0857143 2 0.0857143H22C23.0572 0.0857143 23.9143 0.942769 23.9143 2V3.51429H0.0857143V2Z",
    stroke: "#130E3A",
    strokeWidth: 0.171429
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.88839,
    cy: 1.71456,
    r: 0.857143,
    fill: "#1E1659"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.11496,
    cy: 1.71456,
    r: 0.857143,
    fill: "#1E1659"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.34152,
    cy: 1.71456,
    r: 0.857143,
    fill: "#1E1659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6972 0.85745C22.6706 0.858078 22.6453 0.869211 22.6269 0.888417L21.9431 1.57224L21.2592 0.888417C21.2498 0.878762 21.2386 0.871089 21.2262 0.865855C21.2138 0.86062 21.2005 0.857929 21.187 0.857942C21.167 0.857966 21.1474 0.863958 21.1308 0.875151C21.1142 0.886344 21.1013 0.90223 21.0938 0.92078C21.0863 0.939329 21.0845 0.959701 21.0886 0.979292C21.0927 0.998883 21.1025 1.0168 21.1169 1.03076L21.8007 1.71459L21.1169 2.39841C21.1072 2.40768 21.0995 2.41879 21.0942 2.43109C21.0889 2.44338 21.0861 2.45661 21.0859 2.47001C21.0858 2.4834 21.0883 2.49668 21.0934 2.50908C21.0985 2.52148 21.106 2.53275 21.1154 2.54222C21.1249 2.55169 21.1362 2.55918 21.1486 2.56424C21.161 2.5693 21.1742 2.57184 21.1876 2.5717C21.201 2.57157 21.2143 2.56876 21.2266 2.56344C21.2388 2.55813 21.25 2.55042 21.2592 2.54076L21.9431 1.85693L22.6269 2.54076C22.6362 2.55042 22.6473 2.55813 22.6596 2.56344C22.6719 2.56876 22.6851 2.57157 22.6985 2.5717C22.7119 2.57184 22.7252 2.5693 22.7376 2.56424C22.75 2.55918 22.7612 2.55169 22.7707 2.54222C22.7802 2.53275 22.7876 2.52148 22.7927 2.50908C22.7978 2.49668 22.8003 2.4834 22.8002 2.47001C22.8 2.45661 22.7972 2.44338 22.7919 2.43109C22.7866 2.41879 22.7789 2.40768 22.7692 2.39841L22.0854 1.71459L22.7692 1.03076C22.7839 1.01672 22.7939 0.998573 22.7981 0.978708C22.8022 0.958844 22.8003 0.938187 22.7925 0.919448C22.7847 0.900708 22.7714 0.884761 22.7544 0.873697C22.7374 0.862634 22.7175 0.85697 22.6972 0.85745Z",
    fill: "#1E1659"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1295_13312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.22656,
    y: 3.94238,
    width: 9.25714,
    height: 9.25714,
    rx: 0.857143,
    fill: "#2A235B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39453 4.90674L6.38902 7.18168L5.90167 5.87102L3.39453 4.90674Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 10.1139L3.57467 11.8496L5.32234 11.271L4.48669 10.1013L2.99609 10.1139Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18069 7.87181L4.72266 8.76378L6.48248 8.81199L6.31373 6.83521L5.18069 7.87181Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32422 11.2709L6.29448 10.8852L5.42065 10.1138L5.32422 11.2709Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32422 11.271L6.25225 11.8254L6.29448 10.8853L5.32422 11.271Z",
    fill: "#D7CCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32422 11.2709L5.42065 10.1138H4.48047L5.32422 11.2709Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41157 8.76367L6.26172 9.6998L6.46152 10.7285L6.50626 9.37271L6.41157 8.76367Z",
    fill: "#FB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01172 6.06388L3.59029 8.57102L5.19679 8.03199L6.29029 7.02817L3.39743 4.90674L3.01172 6.06388Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28681 9.58327L4.74396 8.76363L5.19312 8.03174L3.58662 8.57077L2.99609 10.1136H5.41896L6.29279 10.8851L6.45711 10.7285L6.28681 9.58327Z",
    fill: "#FB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42109 9.43867L6.28895 9.72796L6.40949 8.76367H4.74609L5.42109 9.43867Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28973 9.72799L5.42188 9.4387L6.02455 9.14941L6.28973 9.72799Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82348 5.87102L7.33594 7.18168L10.3306 4.90674L7.82348 5.87102Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23944 10.1013L8.41016 11.271L10.1515 11.8496L10.73 10.1139L9.23944 10.1013Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39929 6.8833L7.3125 8.82865L9.00791 8.76366L8.60445 7.99223L7.39929 6.8833Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30888 10.1138L7.44141 10.8852L8.41167 11.2709L8.30888 10.1138Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44141 10.8853L7.47728 11.8254L8.41186 11.271L7.44141 10.8853Z",
    fill: "#D7CCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24877 10.1138H8.30859L8.41139 11.2709L9.24877 10.1138Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51141 11.7429V11.4639H6.21618V11.7429L5.32422 11.271L6.2885 12.0424H7.43909L8.40993 11.271L7.51141 11.7429Z",
    fill: "#BCAAA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3316 4.90674L7.44531 7.02817L8.53245 8.03199L10.1451 8.57102L10.7173 6.06388L10.3316 4.90674Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1442 8.57077L8.53139 8.03174L8.98055 8.76363L7.45852 9.64615L7.31716 8.76363L7.22266 9.37267L7.2674 10.7285L7.26759 10.7271L7.2674 10.7285L7.43808 10.8851L8.30555 10.1136H10.7284L10.1442 8.57077Z",
    fill: "#FB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90234 5.87085L6.28806 7.02799L6.4165 8.8287L6.45527 9.37564L6.45835 10.7285H6.86316V10.7199L6.86354 10.7285H7.26835L7.27144 9.37564L7.3102 8.8287L7.4452 7.02799L7.83091 5.87085H5.90234Z",
    fill: "#FB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44431 10.8852L7.26302 10.6924H6.46189L6.28717 10.8852L6.21484 11.4638H7.51007L7.44431 10.8852Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98371 8.76367H7.32031L7.44085 9.72796L8.30871 9.43867L8.98371 8.76367Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71295 9.14941L8.30926 9.4387L7.44141 9.72799L7.71295 9.14941Z",
    fill: "#212121"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5117,
    y: 3.94238,
    width: 9.25714,
    height: 9.25714,
    rx: 0.857143,
    fill: "#2A235B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1135 6.74002L20.2862 6.31571C20.2862 6.31571 20.0665 6.07991 19.7996 5.81275C19.5328 5.54553 18.9677 5.70273 18.9677 5.70273L18.3241 4.97168H16.0638L15.4202 5.70273C15.4202 5.70273 14.8552 5.54558 14.5883 5.81275C14.3215 6.07997 14.1017 6.3156 14.1017 6.3156L14.2744 6.73991L14.0547 7.3686C14.0547 7.3686 14.7009 9.81963 14.7766 10.119C14.9257 10.7084 15.0277 10.9362 15.4516 11.2348C15.8754 11.5335 16.6445 12.0521 16.7701 12.1307C16.8956 12.2093 17.0526 12.3431 17.1939 12.3431C17.3352 12.3431 17.4921 12.2093 17.6177 12.1307C17.7433 12.0521 18.5124 11.5335 18.9362 11.2348C19.36 10.9362 19.4621 10.7084 19.6112 10.119C19.6869 9.81968 20.3332 7.36865 20.3332 7.36865L20.1135 6.74002Z",
    fill: "url(#paint0_linear_1295_13312)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7876 6.16589C18.7876 6.16589 19.6154 7.16779 19.6154 7.38196C19.6154 7.59607 19.5113 7.65259 19.4065 7.76395L18.7859 8.42383C18.7272 8.48628 18.6049 8.58092 18.6768 8.75131C18.7487 8.92171 18.8548 9.1385 18.7368 9.35843C18.6189 9.57829 18.4168 9.7251 18.2873 9.70083C18.1578 9.67652 17.8537 9.51742 17.7418 9.44474C17.63 9.37207 17.2756 9.0793 17.2756 8.96733C17.2756 8.85535 17.642 8.65427 17.7096 8.60859C17.7774 8.56292 18.0861 8.3861 18.0924 8.31672C18.0987 8.24729 18.0963 8.22694 18.0052 8.05543C17.9141 7.88392 17.75 7.65505 17.7773 7.50277C17.8046 7.35054 18.0693 7.27133 18.2581 7.19994C18.447 7.12855 18.8106 6.99365 18.856 6.97269C18.9014 6.95173 18.8897 6.93177 18.752 6.91869C18.6145 6.90561 18.224 6.85373 18.048 6.90287C17.8719 6.95201 17.5712 7.02675 17.5468 7.06638C17.5225 7.10602 17.501 7.10736 17.526 7.2441C17.551 7.38079 17.6798 8.03692 17.6923 8.15343C17.7048 8.26999 17.7292 8.34702 17.6038 8.37576C17.4783 8.40449 17.267 8.45436 17.1944 8.45436C17.1218 8.45436 16.9105 8.40449 16.785 8.37576C16.6595 8.34702 16.684 8.26999 16.6965 8.15343C16.709 8.03692 16.8378 7.38084 16.8628 7.2441C16.8878 7.10736 16.8664 7.10602 16.842 7.06633C16.8176 7.02675 16.5168 6.95201 16.3408 6.90287C16.1648 6.85373 15.7743 6.90566 15.6368 6.91869C15.4991 6.93177 15.4874 6.95167 15.5328 6.97269C15.5782 6.99365 15.9419 7.12855 16.1307 7.19994C16.3196 7.27133 16.5842 7.35054 16.6115 7.50277C16.6388 7.65505 16.4747 7.88392 16.3836 8.05543C16.2925 8.22694 16.2901 8.24729 16.2964 8.31672C16.3027 8.3861 16.6115 8.56292 16.6792 8.60859C16.7468 8.65427 17.1133 8.85535 17.1133 8.96733C17.1133 9.0793 16.7588 9.37207 16.647 9.44474C16.5352 9.51742 16.2311 9.67652 16.1015 9.70078C15.972 9.7251 15.7699 9.57835 15.652 9.35843C15.534 9.1385 15.6401 8.92171 15.7119 8.75131C15.7839 8.58092 15.6616 8.48628 15.6029 8.42383L14.9822 7.76395C14.8775 7.65259 14.7734 7.59607 14.7734 7.38196C14.7734 7.16785 15.6012 6.16589 15.6012 6.16589C15.6012 6.16589 16.2997 6.2995 16.3939 6.2995C16.4881 6.2995 16.6921 6.2209 16.8805 6.15807C17.0688 6.09517 17.1944 6.09473 17.1944 6.09473C17.1944 6.09473 17.32 6.09517 17.5083 6.15807C17.6967 6.2209 17.9008 6.2995 17.9949 6.2995C18.0891 6.2995 18.7876 6.16589 18.7876 6.16589ZM18.1671 9.99841C18.2183 10.0306 18.187 10.0911 18.1404 10.1241C18.0937 10.1571 17.4664 10.6435 17.4055 10.6973C17.3447 10.751 17.2552 10.8398 17.1944 10.8398C17.1336 10.8398 17.0441 10.751 16.9832 10.6973C16.9223 10.6435 16.2951 10.1572 16.2484 10.1241C16.2018 10.0911 16.1705 10.0306 16.2217 9.99841C16.273 9.96632 16.4333 9.88526 16.6545 9.77066C16.8757 9.65606 17.1514 9.55862 17.1944 9.55862C17.2374 9.55862 17.513 9.65606 17.7343 9.77066C17.9555 9.88526 18.1158 9.96632 18.1671 9.99841Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9652 5.70273L18.3217 4.97168H16.0614L15.4178 5.70273C15.4178 5.70273 14.8528 5.54558 14.5859 5.81275C14.5859 5.81275 15.3393 5.74466 15.5983 6.16634C15.5983 6.16634 16.2969 6.29995 16.3911 6.29995C16.4852 6.29995 16.6892 6.22135 16.8776 6.15851C17.066 6.09562 17.1915 6.09517 17.1915 6.09517C17.1915 6.09517 17.3171 6.09562 17.5055 6.15851C17.6939 6.22135 17.8979 6.29995 17.9921 6.29995C18.0863 6.29995 18.7848 6.16634 18.7848 6.16634C19.0437 5.74466 19.7972 5.81275 19.7972 5.81275C19.5304 5.54553 18.9652 5.70273 18.9652 5.70273Z",
    fill: "url(#paint1_linear_1295_13312)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.22656,
    y: 13.8848,
    width: 9.25714,
    height: 9.25714,
    rx: 0.857143,
    fill: "#2A235B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1295_13312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2834 18.5987C10.2834 16.7525 8.78672 15.2559 6.94051 15.2559C5.0943 15.2559 3.59766 16.7525 3.59766 18.5987C3.59766 20.4449 5.0943 21.9416 6.94051 21.9416C8.78672 21.9416 10.2834 20.4449 10.2834 18.5987Z",
    fill: "#393D4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88834 20.5673C5.34107 20.5673 4.82734 20.4505 4.38281 20.2459L6.19139 18.5951C5.94158 18.3902 5.78221 18.0791 5.78221 17.7307C5.78221 17.3761 5.94744 17.06 6.20512 16.8553V16.6133H6.89204C6.89458 16.6133 6.89711 16.6133 6.89967 16.6133C7.17901 16.6133 7.43442 16.7158 7.63032 16.8852C7.82622 16.7158 8.08161 16.6133 8.36094 16.6133H8.36261L8.36264 16.6133L8.36269 16.6133H9.05547V16.8553C9.31316 17.06 9.4784 17.3761 9.4784 17.7308C9.4784 18.1768 9.21711 18.5617 8.83926 18.741C8.70416 19.1398 8.45005 19.4986 8.10994 19.7904V20.306H7.25498C6.84365 20.4733 6.37952 20.5673 5.88834 20.5673ZM6.89964 18.5903C7.10306 18.5903 7.28997 18.5197 7.43719 18.4016L7.62857 18.8325L7.82086 18.3995C7.96844 18.5189 8.15635 18.5903 8.36094 18.5903C8.83565 18.5903 9.2205 18.2055 9.2205 17.7308C9.2205 17.256 8.83565 16.8712 8.36094 16.8712C8.05246 16.8712 7.78195 17.0337 7.63029 17.2777C7.47864 17.0337 7.20813 16.8712 6.89964 16.8712C6.42491 16.8712 6.04007 17.256 6.04007 17.7308C6.04007 18.2055 6.42491 18.5903 6.89964 18.5903ZM6.89964 18.3325C7.23197 18.3325 7.50136 18.0631 7.50136 17.7308C7.50136 17.3985 7.23197 17.1291 6.89964 17.1291C6.56734 17.1291 6.29793 17.3985 6.29793 17.7308C6.29793 18.0631 6.56734 18.3325 6.89964 18.3325ZM6.89964 18.0746C7.08953 18.0746 7.24349 17.9207 7.24349 17.7308C7.24349 17.5409 7.08953 17.3869 6.89964 17.3869C6.70975 17.3869 6.55583 17.5409 6.55583 17.7308C6.55583 17.9207 6.70975 18.0746 6.89964 18.0746ZM8.96263 17.7308C8.96263 18.0631 8.69324 18.3325 8.36092 18.3325C8.02862 18.3325 7.75923 18.0631 7.75923 17.7308C7.75923 17.3985 8.02862 17.1291 8.36092 17.1291C8.69324 17.1291 8.96263 17.3985 8.96263 17.7308ZM8.70476 17.7308C8.70476 17.9207 8.55083 18.0746 8.36092 18.0746C8.17103 18.0746 8.0171 17.9207 8.0171 17.7308C8.0171 17.5409 8.17103 17.3869 8.36092 17.3869C8.55083 17.3869 8.70476 17.5409 8.70476 17.7308Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1719,
    y: 13.8848,
    width: 9.25714,
    height: 9.25714,
    rx: 0.857143,
    fill: "#2A235B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7151 15.9414C17.5831 16.6664 18.5785 16.6216 18.8629 16.6216C18.8007 20.7444 18.3267 19.9269 16.7151 21.0829C15.1035 19.9269 14.6325 20.7444 14.5703 16.6216C14.8517 16.6216 15.8471 16.6664 16.7151 15.9414Z",
    stroke: "#3375BB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_13312",
    x1: 14.0547,
    y1: 378.747,
    x2: 641.906,
    y2: 378.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40988,
    stopColor: "#FF5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58198,
    stopColor: "#FF2000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1295_13312",
    x1: 25.7797,
    y1: 72.3227,
    x2: 535.712,
    y2: 72.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF452A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_1295_13312"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.22656,
    y: 3.94238,
    width: 9.25714,
    height: 9.25714,
    rx: 0.857143,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "clip1_1295_13312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.68571,
    height: 6.68571,
    fill: "white",
    transform: "translate(3.59766 15.2559)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEvmDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/evm-dark.86422ad05e466214587d0297f3dc412b.svg";